// ----------------------------------------------------------------------

export default function Stepper(theme) {
  return {
    MuiStepConnector: {
      styleOverrides: {
        root: {
          marginLeft: 8,
        },
        line: {
          borderColor: theme.palette.divider,
          minHeight: 15,
        },
      },
    },
    MuiStepIcon: {
      styleOverrides: { root: { width: 17, height: 17 } },
    },
    MuiStepLabel: {
      styleOverrides: { root: { padding: 0 } },
    },
  };
}
